//FB 7074
import {
  Appointment,
  CCDA,
  CreditCardPaymentModel,
  DeleteGuardian,
  EMRConfig,
  Guardian,
  Login,
  Medication,
  Message,
  Patient,
  Physician,
  SelectedPharmacy,
  State,
  TestResult,
  Insurance,
  HeaderLogo,
  ClinicalDocument,
  InvoiceModal,
  LabOrder
} from "../store";//FB 8881 //FB 9639
import Configurations from "../config";
import { getIpDetails } from "../App";
import moment from "moment";  //FB 7528

// Update log
// FB  6192   02/06/2023  DK  Added page to handle API calls
// FB  6905   05/31/2023  SK  PP Changes on Billing invoice screen
// FB  6915   06/06/2023  DK  Test results acknowledgement
// FB  7109   07/19/2023  DK  Test results acknowledgement not working
// FB  7115   07/20/2023  DK  Test results should show session date
// FB  7111   07/25/2023  DK  Password strength meter and green tick feature
// FB  7074   07/14/2023  SK  Patient Portal : Develop the feature of message reply
// FB  7145   07/28/2023  SK  patient portal: update code to make payment screen using 'use card on file' option.
// FB  7075   08/03/2023  DK  Implement direct messaging feature
// FB  7323   09/11/2023  GA  When Payment Comes from the Patient Portal, the Transactions Payment Type Must be Credit Card Patient Portal
// FB  7528   10/05/2023  DK  Issue with DOB field (Picking a day earlier)
// FB  7560   10/10/2023  SK  Orady Portal - Cannot Recover Password
// FB  7683   10/31/2023  DK  Change email address
// FB  7874   12/07/2023  DK  Admin should be able to access patient pages
// FB  8024   01/03/2024  SK  Including Recent Patient Engagement Enhancements to Patient Portal
// FB  8117   01/23/2024  DK  Avoid calling EMR API directly from Portal
// FB  8338   02/23/2024  DK  Clinical docs taking so long to load
// FB  8401   03/08/2024  GA  Portal - EMR API's shouldn't be called from Portal directly - 2
// FB  8568   04/16/2024  DK  Guardian is not able to see the patient profile details
// FB  8881   06/14/2024  SK  Show Billing Details in Portal for All Patients in Guest Login Interface
// FB  8962   06/27/2024  DK  DOB is changing automatically
// FB  8976   07/08/2024  MS  Fixed Invoice Number issue
// FB  8276	  09/02/2024  SK  Feature to allow patients to complete certain forms using Portal
// FB  9372   09/13/2024  GA  Portal UI should not call EMR APIs Directly
// FB  9491   10/09/2024  GA  Portal-Billing > on print invoice and print statement getting error in the console.
// FB  8394   10/16/2024  GS  Staff should not have Dr in front of it
// FB  9464   10/15/2024  KI  created new screen for displaying lab orders.
// FB  9639   12/02/2024  DK  Employee Groups that are Set to be Portal Addressees.
// FB  10390  04/15/2025  DK  Cures Act compliance
// FB  10088   05/15/2025  GS  Allow to send the message from EMR to portal only



export async function FormatDOB(date: any) {
  let DOB = new Date(date);
  let formattedDOB = DOB.toJSON().split("T")[0];
  return formattedDOB;
}

export async function GetEMRURL() {
  const targetUrl =
    Configurations.API +
    "/Registration/getWebsiteId?hostName=" +
    window.location.hostname;
  const response = await fetch(targetUrl);

  if (!response.ok) {
    logError();
  } else {
    const data = await response.json();
    if (data != null) {
      return {
        EMRURL: data.emrUrl,
        WebsiteID: data.webSiteID,
      } as EMRConfig;
    }
  }
}

export async function VerifyPatient(patient: Patient) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    patient.PatientDOB = new Date(moment(patient.PatientDOB).format('yyyy-MM-DD')); //FB 7528
    const targetUrl = Configurations.API + "/api/patient/FindPatientInEMR?websiteID=" + emrConfig.WebsiteID;  //FB 8117
    const config = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },

      body: JSON.stringify(patient),
    };
    const result = await fetch(targetUrl, config);
    if (result.ok) {
      var data = await result.json();
      return data;
    } else {
      logError();
    }
  }
}

export async function GenerateOTP(
  patient: Patient,
  sendEmail: number,
  sendText: number
) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    //FB 8401 Begin
    const targetUrl = Configurations.API + "/api/patient/UpdateVerificationCode?websiteID=" + emrConfig.WebsiteID +
      "&emrID=" +
      patient.EMRID +
      "&sendEmail=" +
      sendEmail +
      "&sendText=" +
      sendText;
    //FB 8401 End

    const response = await fetch(targetUrl);

    if (!response.ok) {
      logError();
    } else {
      return response.statusText;
    }
  }
}

export async function GetOTP(patient_n: string) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    //FB 8401 Begin
    const targetUrl =
      Configurations.API +
      "/api/patient/GetVerificationCode?websiteID=" + emrConfig.WebsiteID +
      "&emrID=" +
      patient_n;
    //FB 8401 End
    const response = await fetch(targetUrl);
    var otp = "";

    if (!response.ok) {
      logError();
    } else {
      otp = await response.json();
      return otp;
    }
  }
}

export async function CheckLoginExistance(patient: Patient) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl =
      Configurations.API +
      "/Registration/checkUserExist?login=" +
      patient.Login +
      "&websiteId=" +
      emrConfig.WebsiteID;
    const response = await fetch(targetUrl);
    let isLoginExists = false;
    var state = "";

    if (!response.ok) {
      logError();
    } else {
      isLoginExists = await response.json();
      if (!isLoginExists) {
        let obj = sessionStorage.getItem("EMRConfig");
        if (obj != null) {
          let emrConfig = JSON.parse(obj) as EMRConfig;
          //FB 8117
          const targetUrl = Configurations.API + "/api/patient/FindPatientInEMRByID?patient_n=" + patient.EMRID + "&websiteID=" + emrConfig.WebsiteID;  //FB 8117
          const response = await fetch(targetUrl);

          if (!response.ok) {
            logError();
          } else {
            const result = await response.json();
            if (result.length > 0) {
              switch (patient.PatientGender) {
                case "1":
                  patient.PatientGender = "male";
                  break;
                case "2":
                  patient.PatientGender = "female";
                  break;
                case "3":
                  patient.PatientGender = "other";
                  break;
              }

              //FB 8117 Start
              patient.PatientCity = result[0].patienT_CITY_STATE_ZIP.split(",")[0];
              patient.PatientPrimaryAddress = result[0].patienT_ADDRESS;
              patient.PatientSecondAddress = result[0].patienT_ADDRESS2;
              patient.WebSiteID = emrConfig.WebsiteID;

              if (result[0].patienT_CITY_STATE_ZIP != "" && result[0].patienT_CITY_STATE_ZIP != null) {
                var state_Zip = result[0].patienT_CITY_STATE_ZIP.split(",")[1];
                if (
                  state_Zip != "" &&
                  state_Zip != undefined &&
                  state_Zip != null
                ) {
                  state = state_Zip.slice(1, 3);
                }
              }
              //FB 8117 End

              patient.BloodTypeID = 1;
              patient.EmploymentStatusID = 1;
              patient.MaritalStatusID = 1;
              patient.StaffID = 1;
              patient.PatientPassword2 = "";

              const targetUrl =
                Configurations.API +
                "/Registration/RegisterUser?state=" +
                state;
              const config = {
                method: "POST",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },

                body: JSON.stringify(patient),
              };
              const response = await fetch(targetUrl, config);

              if (response.ok) {
                const data = await response.json();
                if (data == 0) {
                  return {
                    message: "Account already exists. Please try login",
                    alertType: "Failed",
                  };
                } else {
                  return {
                    message: "Account created successfully!",
                    alertType: "Success",
                  };
                }
              } else {
                return {
                  message: "Account creation failed. Please try again later.",
                  alertType: "Failed",
                };
              }
            } else {
              return {
                message:
                  "Couldn't fetch patient details at this moment. Please try again later.",
                alertType: "Failed",
              };
            }
          }
        } else {
          return {
            message: "Couldn't reach EMR servers. Please try again later.",
            alertType: "Failed",
          };
        }
      } else {
        return {
          message: "Username already exists. Please choose another one.",
          alertType: "Failed",
        };
      }
    }
  }
}

export async function GetAuthenticationToken(loginform: Login) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl =
      Configurations.API +
      "/api/patient/Authenticate?userName=" +
      loginform.Username +
      "&password=" +
      loginform.Password +
      "&websiteID=" +
      emrConfig.WebsiteID;
    const config = {
      method: "POST",
    };
    const response = await fetch(targetUrl, config);

    if (!response.ok) {
      logError();
    } else {
      const data = await response.json();
      if (data != null) {
        sessionStorage.setItem("PP_Auth_Token", data);
      }
    }
  }
}

export async function VerifyLogin(loginform: Login) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    //FB 7111
    const targetUrl =
      Configurations.API +
      "/api/patient/Authenticate?userName=" +
      loginform.Username +
      "&password=" +
      encodeURIComponent(loginform.Password) +
      "&websiteID=" +
      emrConfig.WebsiteID;
    const config = {
      method: "POST",
    };
    const response = await fetch(targetUrl, config);

    if (response.status == 401) {
      var JSAlert = require("js-alert");
      JSAlert.alert(
        "Invalid credentials. Please enter a valid username and password.",
        null,
        JSAlert.Icons.Failed
      );
    } else if (response.ok) {
      const data = await response.text();
      if (data != null) {
        sessionStorage.setItem("PP_Auth_Token", data);
        let obj = sessionStorage.getItem("EMRConfig");
        if (obj != null) {
          let emrConfig = JSON.parse(obj) as EMRConfig;
          //FB 7111
          const url =
            Configurations.API +
            "/Login/verifyLogin?username=" +
            loginform.Username +
            "&password=" +
            encodeURIComponent(loginform.Password) +
            "&isGuardian=" +
            loginform.IsGuardian +
            "&websiteId=" +
            emrConfig.WebsiteID;
          const headers = new Headers();
          headers.append("Authorization", "Bearer " + data);
          const result = await fetch(url, { headers: headers });
          var JSAlert = require("js-alert");

          if (result.status == 404) {
            JSAlert.alert(
              "We couldn't find the account. If you are a guardian, Please check the 'I am a Guardian' checkbox.",
              null,
              JSAlert.Icons.Error
            );
          }
          else if (result.status == 409) {
            return "Existing patient identified";
          }
          else if (result.ok) {
            const res = await result.json();
            return res;
          }
        } else {
          logError();
        }
      }
    }
  } else {
    logError();
  }
}


export async function SendForgotUsername(patient: Patient) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    patient.WebSiteID = emrConfig.WebsiteID;
    const token = sessionStorage.getItem("PP_Auth_Token");
    const targetUrl = Configurations.API + "/Login/ForgotUsername";
    patient.PatientDOB = new Date(moment(patient.PatientDOB).format('yyyy-MM-DD')); //FB 7528
    const config = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },

      body: JSON.stringify(patient),
    };
    const response = await fetch(targetUrl, config);

    if (response.status == 404) {
      return {
        message:
          "Sorry, Couldn't find the account. Please re-check the entered details.",
        alertType: "Failed",
      };
    } else if (response.ok) {
      return {
        message:
          "Username has been sent to the registered email id. Please login using the same.",
        alertType: "Success",
      };
    } else {
      logError();
    }
  }
}

export async function GetAppointments(patient_n: string, timeline: string) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl =
      emrConfig.EMRURL +
      "/api/PatientPortal/GetApptDetail?patient_n=" +
      patient_n +
      "&condition=" +
      timeline;
    const response = await fetch(targetUrl);

    if (!response.ok) {
      logError();
    } else {
      var data = await response.json();
      if (data.length > 0) {
        return data.map((key: any) => {
          return {
            Date: key.APPOINTMENT_DATE,
            Location: key.FACILITY_NAME,
            Provider: key.Employee_Name,
            Type: key.Appointment_Type,
          } as Appointment;
        });
      }
    }
  }
}

// FB 8962
export async function VerifyPatientDemographics(patient: any) {
  // FB 8962 - Removed unused code
  // FB 7560 - Changed the approach of api - Begin
  const targetUrl = Configurations.API + "/forgotPassword/VerifyUser";
  const token = sessionStorage.getItem("PP_Auth_Token");
  const config = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },

    body: JSON.stringify(patient),
  };
  const response = await fetch(targetUrl, config);
  // FB 7560 - End

  if (!response.ok) {
    return {
      message: "We couldn't find the account. Please contact administrator.",
      alertType: "Failed",
    };
  } else {
    const data = await response.json();
    return data;
  }
}

export async function GenerateOTPForForgotPassword(
  login: string,
  sendText: number,
  sendEmail: number,
  websiteID: number
) {
  const targetUrl =
    Configurations.API +
    "/Sms/GenerateVerificationCode?userName=" +
    login +
    "&emailSelect=" +
    sendEmail +
    "&phoneSelect=" +
    sendText +
    "&websiteID=" +
    websiteID;
  const token = sessionStorage.getItem("PP_Auth_Token");
  const headers = new Headers();
  headers.append("Authorization", "Bearer " + token);
  const response = await fetch(targetUrl, { headers: headers });

  if (!response.ok) {
    logError();
  } else {
    return response.statusText;
  }
}

export async function GetOTPForForgotPassword(login: string) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl =
      Configurations.API +
      "/Sms/VerificationCode?userName=" +
      login +
      "&websiteID=" +
      emrConfig.WebsiteID;
    const token = sessionStorage.getItem("PP_Auth_Token");
    const headers = new Headers();
    headers.append("Authorization", "Bearer " + token);
    const response = await fetch(targetUrl, { headers: headers });

    if (!response.ok) {
      logError();
    } else {
      const data = await response.json();
      return data;
    }
  }
}

export async function ResetUserPassword(login: string, password: string) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl =
      Configurations.API +
      "/ForgotPassword/updatePassword?userName=" +
      login +
      "&Password=" +
      password +
      "&websiteID=" +
      emrConfig.WebsiteID;
    const token = sessionStorage.getItem("PP_Auth_Token");
    const headers = new Headers();
    headers.append("Authorization", "Bearer " + token);
    const config = {
      method: "PUT",
      headers: headers,
    };
    const response = await fetch(targetUrl, config);

    if (!response.ok) {
      logError();
    } else {
      return response.statusText;
    }
  }
}

// FB 7874
export async function ResetPassword(
  userName: string,
  password: string,
  newPassword: string,
  userType: string
) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    // FB 7874
    const targetUrl =
      Configurations.API +
      "/updatePswd?userName=" +
      userName +
      "&password=" +
      password +
      "&newPassword=" +
      encodeURIComponent(newPassword) +
      "&websiteID=" +
      emrConfig.WebsiteID + "&userType=" + userType;
    const token = sessionStorage.getItem("PP_Auth_Token");
    const headers = new Headers();
    headers.append("Authorization", "Bearer " + token);

    const config = {
      method: "PUT",
      headers: headers,
    };
    const response = await fetch(targetUrl, config);
    if (response.status == 404) {
      return {
        message: "Entered Current Password is not valid.",
        alertType: "Failed",
      };
    } else if (response.ok) {
      return { message: "Password reset is successful.", alertType: "Success" };
    } else {
      logError();
    }
  }
}

export async function GetTestResults(patient_n: string) {
  const targetUrl =
    Configurations.API + "/testResultData?patientID=" + patient_n;
  const token = sessionStorage.getItem("PP_Auth_Token");
  const headers = new Headers();
  headers.append("Authorization", "Bearer " + token);
  const response = await fetch(targetUrl, { headers: headers });

  if (!response.ok) {
    logError();
  } else {
    const data = await response.json();
    if (data.length > 0) {
      return data.map((key: any) => {
        return {
          TestType: key.typeName,
          //FB 7115
          TestDate: key.testDate,
          Physician: key.physicianName,
          DocumentID: key.documentID,
          Annotation: key.annotation,
          EMRID: key.emrid,
          //FB 6915
          IsReviewed: key.isReviewed,
          PatientID: key.patientID,
          AcknowledgedOn: key.acknowledgedOn
        } as TestResult;
      });
    }
  }
}

//FB 6915
//FB 7109
export async function AcknowledgeTestResults(emrid: number, patient_id: number, documentID: number) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    //FB 6915
    //FB 7109
    const targetUrl = Configurations.API + "/testResultAck?EMRID=" + emrid +
      "&WebsiteID=" + emrConfig.WebsiteID + "&PatientID=" + patient_id + "&DocumentID=" + documentID;
    const token = sessionStorage.getItem("PP_Auth_Token");
    const headers = new Headers();
    headers.append("Authorization", "Bearer " + token);
    const response = await fetch(targetUrl, { headers: headers });

    if (!response.ok) {
      logError();
    } else {
      return response.statusText;
    }
  }
}

// export async function GetResultDocuments(docid: number) {
//   const targetUrl = Configurations.API + "/Getimage?docid=" + docid;
//   const token = sessionStorage.getItem("PP_Auth_Token");
//   const headers = new Headers();
//   headers.append("Authorization", "Bearer " + token);
//   const response = await fetch(targetUrl, { headers: headers });

//   if (!response.ok) {
//     logError();
//   } else {
//     const data = await response.json();
//     return data;
//   }
// }

export async function GetResultDocuments(emrid: number) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    //FB 8401 Begin
    const targetUrl = Configurations.API + "/api/patient/GetClinicalDocument?websiteID=" + emrConfig.WebsiteID +
      "&session_n=" + emrid + "&password=Welcome_to_the_real_world";
    //FB 8401 End
    const response = await fetch(targetUrl);

    if (!response.ok) {
      logError();
    } else {
      let bytes: Blob = await response.blob();
      return bytes;
    }
  }
}

//FB 9464 strat
export async function GetLabOrderDocuments(laborderId: number) {
  console.log(laborderId);
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl = Configurations.API + "/api/patient/GetLabOrder?websiteID=" + emrConfig.WebsiteID +
      "&laborder_n=" + laborderId + "&password=Welcome_to_the_real_world&EMR_URL=" + emrConfig.EMRURL;
    const response = await fetch(targetUrl);

    if (!response.ok) {
      logError();
    } else {
      let bytes: Blob = await response.blob();
      return bytes;
    }
  }
}

export async function GetLabOrders(patient_n: number) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    //FB 8401 Begin
    const targetUrl = Configurations.API + "/api/Patient/GetLabOrders?websiteID=" + emrConfig.WebsiteID
      + "&patient_n=" + patient_n + "&password=Welcome_to_the_real_world";
    //FB 8401 End
    const response = await fetch(targetUrl);
    if (!response.ok) {
      logError();
    } else {
      const data = await response.json();
      if (data.length > 0) {
        return data.map((key: any) => {
          return {
            LAB_ORDER_N: key.LAB_ORDER_N,
            LAB_ORDER_MODIFY_DATE: key.LAB_ORDER_MODIFY_DATE,
            LABORATORY_NAME: key.LABORATORY_NAME,
            EMPLOYEE_FIRST_NAME: key.EMPLOYEE_FIRST_NAME
          } as LabOrder;
        });
      }
    }
  }
}
//FB 9464 end


function decodeHtml(html: string): string {
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}


export async function GetDocumentHTML(emrid: number) {
  const obj = sessionStorage.getItem("EMRConfig");
  if (!obj) return "";

  const emrConfig = JSON.parse(obj) as EMRConfig;

  // Fetch HTML from EMR
  const targetUrl = `${Configurations.API}/api/Patient/GetClinicalDocument/html?websiteID=${emrConfig.WebsiteID}&session_n=${emrid}&password=Welcome_to_the_real_world&EMR_URL=${emrConfig.EMRURL}`;
  const response = await fetch(targetUrl);
  if (!response.ok) return "";

  let html = await response.text();

  // Decode HTML entities
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  html = txt.value;

  // Clean up escaped sequences
  html = html
      .replace(/\\r\\n/g, "")
      .replace(/\\n/g, "")
      .replace(/\\t/g, "")
      .replace(/\r?\n/g, "")
      .replace(/\t/g, "")
      .replace(/\\\"/g, '"')
      .replace(/\\'/g, "'")
      .trim();

  // Fix relative paths to absolute EMR URLs
  html = html
      .replace(/src=(["'])\/img\//gi, `src=$1${emrConfig.EMRURL}/img/`)
      .replace(/src=(["'])\/media\/patients\//gi, `src=$1${emrConfig.EMRURL}/media/patients/`)
      .replace(/src=(["'])\/drawing\//gi, `src=$1${emrConfig.EMRURL}/drawing/`)
      .replace(/src=(["'])\/zygote\//gi, `src=$1${emrConfig.EMRURL}/zygote/`)
      .replace(/href=(["'])\/assets\//gi, `href=$1${emrConfig.EMRURL}/assets/`)
      .replace(/src=(["'])\/assets\//gi, `src=$1${emrConfig.EMRURL}/assets/`);

  // Optional: fallback image if broken
  html = html.replace(/<img([^>]+)>/gi, (match, group1) => {
      if (!/onerror=/i.test(group1)) {
          return `<img${group1} onerror="this.src='${emrConfig.EMRURL}/img/broken-image.png'">`;
      }
      return match;
  });

  // Replace any drawing div with an iframe pointing to EMR drawing.asp
  html = html.replace(
      /<div[^>]+id="signature-pad"[^>]*>[\s\S]*?<\/div>/gi,
      `<iframe src="${emrConfig.EMRURL}/drawing/drawing.asp?readonly=1&TEMPLATE_ROW_N=218937&uid=1736947791612" style="width: 100%; height: 410px; padding-top: 3px; border: none;"></iframe>`
  );

  return html;
}



// Add this new function to load canvas data AFTER HTML is inserted into DOM
export function LoadCanvasDataIntoIframe(emrid: number) {
  // Wait for DOM to be ready
  setTimeout(() => {
    const iframe = document.getElementById(`drawing-iframe-${emrid}`) as HTMLIFrameElement;
    const canvasDataElement = document.getElementById(`canvasData${emrid}`);
    
    if (iframe && canvasDataElement) {
      const canvasDataValue = canvasDataElement.getAttribute("value") || 
                              (canvasDataElement as HTMLInputElement)?.value || "";
      
      if (canvasDataValue) {
        // Update iframe src with hash
        const currentSrc = iframe.src.split('#')[0]; // Remove existing hash if any
        iframe.src = currentSrc + '#data=' + encodeURIComponent(canvasDataValue);
      }
    }
  }, 100);
}




export async function GetInboxMessages(patient_n: string) {
  const targetUrl = Configurations.API + "/GetInbox?patient_id=" + patient_n;
  const token = sessionStorage.getItem("PP_Auth_Token");
  const headers = new Headers();
  headers.append("Authorization", "Bearer " + token);
  const response = await fetch(targetUrl, { headers: headers });

  if (!response.ok) {
    logError();
  } else {
    const data = await response.json();
    if (data.length > 0) {
      return data.map((key: any) => {
        return {
          ID: key.messagesID,
          Subject: key.subject,
          Body: key.body,
          DateCreated: key.dateCreate,
          DateSent: key.dateSent,
          IsRead: key.isRead,
          Priority: key.priority,
          Direction: key.direcion,
          PhysicianID: key.physicianID,
          Is_Group_Message: key.is_Group_Message  //FB 9639
        } as Message;
      });
    }
  }
}

// FB 7074 - Begin
export async function GetSelectedMessage(messageID: number) {
  const targetUrl = Configurations.API + "/GetSelectedMessage?messageID=" + messageID;
  const token = sessionStorage.getItem("PP_Auth_Token");
  const headers = new Headers();
  headers.append("Authorization", "Bearer " + token);
  const response = await fetch(targetUrl, { headers: headers });

  if (!response.ok) {
    logError();
    return {} as Message;   //FB 9639
  } else {
    const data = await response.json();
    //FB 9639
    if (data != null) {
      return {
        ID: data.messagesID,
        Subject: data.subject,
        Body: data.body,
        DateCreated: data.dateCreate,
        DateSent: data.dateSent,
        IsRead: data.isRead,
        Priority: data.priority,
        Direction: data.direcion,
        PhysicianID: data.physicianID,
        Is_Group_Message: data.is_Group_Message
      } as Message;
    } else {
      return {} as Message;
    }
  }
}
// FB 7074- End

//FB 9639
export async function SendMessage(
  patientID: number,
  selectedPhysicianID: number,
  subject: string,
  content: string,
  Is_Group: boolean
) {
  const token = sessionStorage.getItem("PP_Auth_Token");

  const headers = new Headers();

  headers.append("Authorization", "Bearer " + token);
  //FB 9639
  const targetUrl = Configurations.API + "/SendMsgToEmr?patientID=" + patientID + "&empID=" + selectedPhysicianID + "&subject=" +
    subject + "&body=" + content + "&is_group=" + Is_Group;
  const config = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const response = await fetch(targetUrl, config);

  if (!response.ok) {
    logError();
  } else {
    const result = await response;
  }
}

//FB 6905 - Start
export async function PatientData(patient: number) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl = Configurations.API + "/api/patient/GetPatientInfoForBilling?patient_n=" + patient + "&websiteID=" + emrConfig.WebsiteID;  //FB 8117



    const response = await fetch(targetUrl);
    if (!response.ok) {
      logError();
    } else {
      const data = await response.json();
      return data;
    }
  }
}

export async function InvoiceData(patient: number) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl =
      emrConfig.EMRURL +
      "/api/PatientPortal/GetInvoiceData?patient_n=" +
      patient;
    const response = await fetch(targetUrl);
    if (!response.ok) {
      logError();
    } else {
      const data = await response.json();
      return data;
    }
  }
}

//FB 8881 - Begin
//FB 8976 - Added patient_n as input param
export async function InvoiceNumber(patient: number) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl =
      emrConfig.EMRURL +
      "/api/PatientPortal/GetInvoiceNumber?patient_n=" +
      patient;
    const response = await fetch(targetUrl);
    if (!response.ok) {
      logError();
    } else {
      const data = await response.json();
      return data;
    }
  }
}

export async function PostInvoiceNumber(im: InvoiceModal) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl =
      emrConfig.EMRURL +
      "/api/billing/portal_invoice"; //FB 9491
    const config = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },

      body: JSON.stringify(im),
    };
    const result = await fetch(targetUrl, config);
    if (!result.ok) {
      logError();
    }
  }
}

//FB 8276 - Begin
export async function GetFormsData(patient: number) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl =
      emrConfig.EMRURL +
      "/api/PatientPortal/GetFormsData?patient_n=" +
      patient;

    const response = await fetch(targetUrl);
    if (!response.ok) {
      logError();
    } else {
      const data = await response.json();
      return data;
    }
  }
}

export async function GetTemplateAndCategory(templatename: number) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl =
      emrConfig.EMRURL +
      "/api/PatientPortal/GetTemplateAndCategory?templatename=" +
      templatename;
    const response = await fetch(targetUrl);
    if (!response.ok) {
      logError();
    } else {
      const data = await response.json();
      return data;
    }
  }
}

export async function UpdateFormsData(patient_n: any, formName: any, templatename: string) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl =
      emrConfig.EMRURL +
      "/api/PatientPortal/UpdateFormsData?patient_n=" +
      patient_n + "&formName=" + formName + "&templatename=" + templatename;
    const response = await fetch(targetUrl);
    if (!response.ok) {
      logError();
    }
  }
}

//FB 8276 - End

export async function GetPortalEmployeeN() {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl =
      emrConfig.EMRURL + "/api/employee/GetPortalEmployeeN";
    const response = await fetch(targetUrl);
    if (!response.ok) {
      logError();
    } else {
      return response.json();
    }
  }
}
//FB 8881 - End

export async function AdminInvoiceData() {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl =
      emrConfig.EMRURL + "/api/PatientPortal/GetInvoiceAdminData";
    const response = await fetch(targetUrl);
    if (!response.ok) {
      logError();
    } else {
      return response.json();
    }
  }
}

export async function AdminSetting(data: string) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl =
      emrConfig.EMRURL +
      "/api/Provider/GetAdminSettingValue?settingName=" +
      data;
    const response = await fetch(targetUrl);
    if (!response.ok) {
      logError();
    } else {
      return response.json();
    }
  }
}
//FB 6905 - End

export async function GetSentMessages(patient_n: string) {
  const targetUrl = Configurations.API + "/GetSentMsg?patientID=" + patient_n;
  const token = sessionStorage.getItem("PP_Auth_Token");
  const headers = new Headers();
  headers.append("Authorization", "Bearer " + token);
  const response = await fetch(targetUrl, { headers: headers });

  if (!response.ok) {
    logError();
  } else {
    const data = await response.json();
    if (data.length > 0) {
      return data.map((key: any) => {
        return {
          ID: key.messagesID,
          Subject: key.subject,
          Body: key.body,
          DateCreated: key.dateCreate,
          DateSent: key.dateSent,
          IsRead: key.isRead,
          Priority: key.priority,
          Direction: key.direcion,
          PhysicianID: key.physicianID,
          Is_Group_Message: key.is_Group_Message  //FB 9639
        } as Message;
      });
    }
  }
}

export async function GetAllPhysicians() {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl =
      Configurations.API + "/GetAllPhysicians?websiteID=" + emrConfig.WebsiteID;
    const token = sessionStorage.getItem("PP_Auth_Token");
    const headers = new Headers();
    headers.append("Authorization", "Bearer " + token);
    const response = await fetch(targetUrl, { headers: headers });

    if (!response.ok) {
      logError();
    } else {
      const data = await response.json();
      if (data.length > 0) {
        return data.map((key: any) => {
          //FB 9639
          return {
            ID: key.physicianID,
            Name: key.physicianName,
          } as Physician;
        });
      }
    }
  }
}

export async function getPatientDetails(login: string) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl =
      Configurations.API +
      "/api/patient/getPatientDetailsByLogin?login=" +
      login +
      "&websiteID=" +
      emrConfig.WebsiteID;
    const token = sessionStorage.getItem("PP_Auth_Token");
    const headers = new Headers();
    headers.append("Authorization", "Bearer " + token);
    const response = await fetch(targetUrl, { headers: headers });
    if (!response.ok) {
      logError();
    } else {
      const result = await response.json();
      if (result != null) {
        return {
          PatientFirstName: result.patientFirstName,
          PatientLastName: result.patientLastName,
          PatientDOB: result.patientDOB,
          PatientGender: result.patientGender,
          PatientPrimaryAddress: result.patientPrimaryAddress,
          PatientSecondAddress: result.patientSecondAddress,
          PatientCity: result.patientCity,
          StateID: result.stateID,
          PatientZIP: result.patientZIP,
          PatientCellPhone: result.patientCellPhone,
          PatientEmail: result.patientEmail,
          InsuranceName: result.patientInsuranceCarriers,
        } as Patient;
      }
    }
  }
}

//FB 8568
export async function getGuardianDetails(login: string) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl = Configurations.API + "/api/patient/getGuardianDetailsByLogin?login=" + login + "&websiteID=" + emrConfig.WebsiteID;
    const token = sessionStorage.getItem("PP_Auth_Token");
    const headers = new Headers();
    headers.append("Authorization", "Bearer " + token);
    const response = await fetch(targetUrl, { headers: headers });
    if (!response.ok) {
      logError();
    } else {
      const result = await response.json();
      if (result != null) {
        return {
          Auth_FirstName: result.auth_FirstName,
          Auth_LastName: result.auth_LastName,
          Auth_DOB: result.auth_DOB,
        } as Guardian;
      }
    }
  }
}

export async function GetInsuranceDetails(patient: any) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl =
      emrConfig.EMRURL + "/api/getinsurancenumber?patient_n=" + patient;
    const result = await fetch(targetUrl);
    if (result.ok) {
      var data = await result.json();

      return data.map((key: any) => {
        return {
          PATIENT_INSURANCE_CARRIER_ID: key.PATIENT_INSURANCE_CARRIER_ID,
          PATIENT_INSURANCE_CARRIER: key.PATIENT_INSURANCE_CARRIER,
          PATIENT_SECONDARY_INSURANCE_CARRIER_ID:
            key.PATIENT_SECONDARY_INSURANCE_CARRIER_ID,
          PATIENT_SECONDARY_INSURANCE_CARRIER:
            key.PATIENT_SECONDARY_INSURANCE_CARRIER,
          PATIENT_THIRD_INSURANCE_CARRIER_ID:
            key.PATIENT_THIRD_INSURANCE_CARRIER_ID,
          PATIENT_THIRD_INSURANCE_CARRIER: key.PATIENT_THIRD_INSURANCE_CARRIER,
          PATIENT_INSURANCE_CARRIER_GROUP: key.PATIENT_INSURANCE_CARRIER_GROUP,
          PATIENT_SECONDARY_INSURANCE_CARRIER_GROUP:
            key.PATIENT_SECONDARY_INSURANCE_CARRIER_GROUP,
          PATIENT_THIRD_INSURANCE_CARRIER_GROUP:
            key.PATIENT_THIRD_INSURANCE_CARRIER_GROUP,
        } as Insurance;
      });
    } else {
      logError();
    }
  }
}
export async function GetStateDetailsById(id: number) {
  const targetUrl =
    Configurations.API + "/Payment/getStateDetailsById?Id=" + id;
  const token = sessionStorage.getItem("PP_Auth_Token");
  const headers = new Headers();
  headers.append("Authorization", "Bearer " + token);
  const response = await fetch(targetUrl, { headers: headers });

  if (!response.ok) {
    logError();
  } else {
    const data = await response.json();
    return data;
  }
}

export async function finalPayment(cc: CreditCardPaymentModel) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl = emrConfig.EMRURL + "/api/cc/finalPayment";

    const config = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },

      body: JSON.stringify(cc),
    };
    const response = await fetch(targetUrl, config);
    if (!response.ok) {
      logError();
    } else {
      const result = await response.json();
      return result;
    }
  }
}

export async function FinalPaymentUsingToken(
  token: string,
  amount: number,
  employee_n: number,//FB 7145
  EMRID: number //FB 7145
) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl =
      emrConfig.EMRURL +
      "/api/cc/finalPaymentUsingToken?token=" +
      token +
      "&amount=" +
      amount +
      "&employee_n=" +
      employee_n +//FB 7145 - Begin
      "&patient_n=" +
      EMRID +//FB 7145 - End
      "&IS_PORTAL_PAYMENT=" + 1;//FB 7323 Begin


    const config = {
      method: "POST",
    };
    const result = await fetch(targetUrl, config);
    if (result.ok) {
      var data = await result.json();
      return data;
    } else {
      logError();
    }
  }
}

export async function GetPaymentToken(SID: string) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl = emrConfig.EMRURL + "/api/cc/paymentToken?SID=" + SID;
    const result = await fetch(targetUrl);
    if (result.ok) {
      var data = await result.json();
      if (data != null) {
        return data.Session.PaymentToken;
      }
    } else {
      logError();
    }
  }
}

export async function GetStates() {
  const targetUrl = Configurations.API + "/Payment/getStates";
  const token = sessionStorage.getItem("PP_Auth_Token");
  const headers = new Headers();
  headers.append("Authorization", "Bearer " + token);
  const response = await fetch(targetUrl, { headers: headers });

  if (!response.ok) {
    logError();
  } else {
    const data = await response.json();
    if (data.length > 0) {
      return data.map((key: any) => {
        return {
          StateID: key.stateID,
          StateShortName: key.stateShortName,
          StateFullName: key.stateFullName,
        } as State;
      });
    }
  }
}

export async function postIframedata() {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl = emrConfig.EMRURL + "/api/cc/paymentUrl";
    const config = {
      method: "POST",
    };
    const response = await fetch(targetUrl, config);
    if (!response.ok) {
      logError();
    } else {
      var iframedata = await response.json();
      return iframedata;
    }
  }
}

export async function SameAsPatient(patient_n: string) {
  const targetUrl =
    Configurations.API + "/Payment/getPatientDetailsById?id=" + patient_n;
  const token = sessionStorage.getItem("PP_Auth_Token");
  const headers = new Headers();
  headers.append("Authorization", "Bearer " + token);
  const response = await fetch(targetUrl, { headers: headers });

  if (!response.ok) {
    logError();
  } else {
    const result = await response.json();
    return result;
  }
}

export async function GetSavedCards(patient_n: number) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl =
      emrConfig.EMRURL + "/api/getCardName?patient_n=" + patient_n;
    const response = await fetch(targetUrl);

    if (!response.ok) {
      logError();
    } else {
      const data = await response.json();
      return data;
    }
  }
}

export async function GetMedications(patient_n: string) {
  const targetUrl =
    Configurations.API +
    "/api/Medications/GetMedications?patient_n=" +
    patient_n;
  const token = sessionStorage.getItem("PP_Auth_Token");
  const headers = new Headers();
  headers.append("Authorization", "Bearer " + token);
  const response = await fetch(targetUrl, { headers: headers });

  if (!response.ok) {
    logError();
  } else {
    const data = await response.json();
    if (data.length > 0) {
      return data.map((key: any) => {
        return {
          ID: key.medicationPatientID,
          Name: key.medicationPatientName,
          Strength: key.medicationPatientStrength,
          Dosage: key.medicationPatientDosing,
          ModifyDate: key.medicationPatientModifyDate,
          CreateDate: key.medicationPatientCreateDate,
          Pharmacy: key.pharmacy,
        } as Medication;
      });
    }
  }
}

export async function GetCCDA(EMRID: string) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl =
      Configurations.API +
      "/GetCCDA?websiteId=" +
      emrConfig.WebsiteID +
      "&EMRID=" +
      EMRID;
    const token = sessionStorage.getItem("PP_Auth_Token");
    const headers = new Headers();
    headers.append("Authorization", "Bearer " + token);
    const response = await fetch(targetUrl, { headers: headers });

    if (!response.ok) {
      logError();
    } else {
      const data = await response.json();
      if (data.length > 0) {
        return data.map((key: any) => {
          return {
            ID: key.ccdaid,
            Date: key.created_Date,
            XML: key.ccdA_XML,
          } as CCDA;
        });
      }
    }
  }
}

export async function GetCCDAData(emrid: number, start: string, end: string) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl =
      Configurations.API +
      "/getCcdData?emrID=" +
      emrid +
      "&websiteID=" +
      emrConfig.WebsiteID +
      "&start=" +
      start +
      "&end=" +
      end;
    const token = sessionStorage.getItem("PP_Auth_Token");
    const headers = new Headers();
    headers.append("Authorization", "Bearer " + token);
    const response = await fetch(targetUrl, { headers: headers });

    if (!response.ok) {
      logError();
    } else {
      const data = await response.json();
      return data;
    }
  }
}

export async function SendMailApi(
  ccdadata: any,
  emrid: number,
  start: string,
  end: string
) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const token = sessionStorage.getItem("PP_Auth_Token");
    const headers = new Headers();
    headers.append("Authorization", "Bearer " + token);
    const targetUrl =
      Configurations.API +
      "/saveSelectedFiles?ccd=" +
      ccdadata +
      "&emrID=" +
      emrid +
      "&websiteID=" +
      emrConfig.WebsiteID +
      "&start=" +
      start +
      "&end=" +
      end;
    const config = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },

      // body: JSON.stringify(ccdadata),
    };
    const result = await fetch(targetUrl, config);
    if (result.ok) {
      var data = await result.json();
      return data;
    } else {
      logError();
    }
  }
}

export async function MailSendingApi(
  ccdadata: any,
  emailaddress: any,
  subject: any,
  content: any
) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const token = sessionStorage.getItem("PP_Auth_Token");
    const headers = new Headers();
    headers.append("Authorization", "Bearer " + token);
    // FB 7683
    const targetUrl =
      Configurations.API +
      "/simpleEmail?websiteID=" + emrConfig.WebsiteID + "&paths=" +
      ccdadata +
      "&emailTo=" +
      emailaddress +
      "&subject=" +
      subject +
      "&content=" +
      content;
    const config = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },

      // body: JSON.stringify(ccdadata),
    };
    const result = await fetch(targetUrl, config);
    if (result.ok) {
      var data = await result.json();
      return data;
    } else {
      logError();
    }
  }
}

export async function UpdateProfile(
  id: any,
  portalDetails: any,
  emailaddress: any,
  content: any
) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const token = sessionStorage.getItem("PP_Auth_Token");
    const headers = new Headers();
    headers.append("Authorization", "Bearer " + token);
    const targetUrl =
      Configurations.API +
      "/updateProfile?id=" +
      id +
      "&websiteID=" +
      emrConfig.WebsiteID +
      "&portal=" +
      portalDetails +
      "&emailTo=" +
      emailaddress +
      "&content=" +
      content;
    const config = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },

      // body: JSON.stringify(ccdadata),
    };
    console.log(targetUrl);
    const result = await fetch(targetUrl, config);
    //if (result.ok) {
    // var data = await result.json();
    // return data;
    // return result.statusText;
    if (result.status == 200) {
      return {
        message:
          "Your request for updating profile details has been sent successfully!",
        alertType: "Success",
      };
    } else {
      return {
        message:
          "Please contact office as we are facing trouble sending email.",
        alertType: "Failed",
      };
    }
  } else {
    logError();
  }
}

//FB 9372
export async function GetDocumentCategories() {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;

    const targetUrl = Configurations.API + "/api/Patient/GetDocumentCategories?websiteID=" + emrConfig.WebsiteID;

    const response = await fetch(targetUrl);

    if (!response.ok) {
      return {
        message:
          "Error occured",
        alertType: "Failed",
      };
    } else {
      var data = await response.json();
      const categories = typeof data === "string" ? data : data?.DocumentCategories ?? "";
      return categories;
    }
  }
}

//FB 7075
export async function InsertPPLogs(
  action: string,
  pageURL: string,
  username: string,
  emailID: string,
  status: string = ""
) {
  //FB 7874 - Start
  let isAdmin = false;
  let obj = sessionStorage.getItem("is_admin");
  if (obj != null && obj != undefined && obj == "1") {
    isAdmin = true;
  }

  if (!isAdmin) {
    await getIpDetails();
    let obj = sessionStorage.getItem("EMRConfig");
    if (obj != null) {
      let emrConfig = JSON.parse(obj) as EMRConfig;
      const url = Configurations.API;
      const token = sessionStorage.getItem("PP_Auth_Token");
      const headers = new Headers();
      headers.append("Authorization", "Bearer " + token);
      //FB 7075
      const targetUrl =
        url +
        "/PatientPortalLog?patientlogIP=" +
        Configurations.clientIp +
        "&patientlogPage=" +
        action +
        "&patientPageURL=" +
        pageURL +
        "&userName=" +
        username +
        "&transmitTo=" +
        emailID +
        "&websiteID=" +
        emrConfig.WebsiteID + "&status=" + status;

      const config = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      };
      return fetch(targetUrl, config).then((response) => response.ok);
    }
  }
}
//FB 7874 - End

export async function GetFacilityEmailID(patient_n: number) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl =
      emrConfig.EMRURL + "/api/GetFacilityEmailID?patientId=" + patient_n;
    const response = await fetch(targetUrl);

    if (!response.ok) {
      return {
        message:
          "Please contact office as we are facing trouble sending email.",
        alertType: "Failed",
      };
    } else {
      var data = await response.json();
      return data;
    }
  }
}

export async function GetActivityLogs(
  patient_n: string,
  start: string,
  end: string
) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl =
      Configurations.API +
      "/getActivityLog?login=" +
      patient_n +
      "&start=" +
      start +
      "&end=" +
      end +
      "&websiteID=" +
      emrConfig.WebsiteID;
    const token = sessionStorage.getItem("PP_Auth_Token");
    const headers = new Headers();
    headers.append("Authorization", "Bearer " + token);
    const response = await fetch(targetUrl, { headers: headers });

    if (!response.ok) {
      logError();
    } else {
      const data = await response.json();
      return data;
    }
  }
}
export async function GetGuardianAccounts(patient_n: string) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl =
      Configurations.API +
      "/Registration/getAuthorizeAccount?login=" +
      patient_n +
      "&websiteID=" +
      emrConfig.WebsiteID;
    const token = sessionStorage.getItem("PP_Auth_Token");
    const headers = new Headers();
    headers.append("Authorization", "Bearer " + token);
    const response = await fetch(targetUrl, { headers: headers });

    if (!response.ok) {
      logError();
    } else {
      const data = await response.json();
      return data;
    }
  }
}
export async function RegisterGuardian(guardian: Guardian) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    guardian.Auth_DOB = new Date(moment(guardian.Auth_DOB).format('yyyy-MM-DD')); //FB 7528
    guardian.WebsiteID = emrConfig.WebsiteID;
    const token = sessionStorage.getItem("PP_Auth_Token");
    const headers = new Headers();
    headers.append("Authorization", "Bearer " + token);
    const targetUrl =
      Configurations.API + "/Registration/AuthAccountRegistration";
    const config = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },

      body: JSON.stringify(guardian),
    };
    const result = await fetch(targetUrl, config);
    if (result.ok) {
      return {
        message: "Account created successfully!",
        alertType: "Success",
      };
    } else {
      return {
        message: await result.text(),
        alertType: "Error",
      };
    }
  }
}
export async function GetPharmacy(
  Name: string,
  Address: string,
  City: string,
  State: string,
  Zip: string,
  Phone: string,
  Fax: string
) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl =
      emrConfig.EMRURL +
      "/api/findPharmacy?RcopiaID=&NCPDPID=&Name=" +
      Name +
      "&Address=" +
      Address +
      "&City=" +
      City +
      "&State=" +
      State +
      "&Zip=" +
      Zip +
      "&Phone=" +
      Phone +
      "&Fax=" +
      Fax +
      "&Is24Hour=&MailOrder=&Retail=&CanReceiveControlledSubstance=&Specialty=&LongTermCare=";
    const config = {
      method: "POST",
    };
    const response = await fetch(targetUrl, config);
    if (!response.ok) {
      logError();
    } else {
      const data = await response.json();
      return data;
    }
  }
}

export async function AccountDisabling(disableGuardian: DeleteGuardian) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    disableGuardian.WebsiteID = emrConfig.WebsiteID;
    const token = sessionStorage.getItem("PP_Auth_Token");
    const headers = new Headers();
    headers.append("Authorization", "Bearer " + token);

    const targetUrl =
      Configurations.API +
      "/Registration/AuthAccountDisabling?patientId=" +
      disableGuardian.patientid +
      "&websiteID=" +
      disableGuardian.WebsiteID +
      "&authLogin=" +
      disableGuardian.Auth_Login;
    const config = {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    };
    const result = await fetch(targetUrl, config);
    if (result.ok) {
      return {
        message: "Account Deleted successfully!",
        alertType: "Success",
      };
    } else {
      return {
        message: await result.text(),
        alertType: "Error",
      };
    }
  }
}
export async function UpdatePharmacyDetails(
  patient: any,
  sp: SelectedPharmacy
) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl =
      emrConfig.EMRURL + "/api/UpdatePharmacy?patient_id=" + patient;

    const config = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },

      body: JSON.stringify(sp),
    };
    const response = await fetch(targetUrl, config);
    if (!response.ok) {
      logError();
    } else {
      const result = await response.json();

      return result;
    }
  }
}
export async function GetPharmacySession(dataph: any) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    //FB 8117
    dataph.PatientDOB = new Date(moment(dataph.PatientDOB).format('yyyy-MM-DD'));
    dataph.PatientGender = dataph.PatientGender.toString();
    const targetUrl = Configurations.API + "/api/patient/FindPatientInEMR?websiteID=" + emrConfig.WebsiteID;  //FB 8117
    const config = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },

      body: JSON.stringify(dataph),
    };
    const response = await fetch(targetUrl, config);

    if (!response.ok) {
      logError();
    } else {
      const data = await response.json();  //FB 8117
      if (data != null) {
        //FB 8117
        sessionStorage.setItem("Pharmacydetails", JSON.stringify(data));
      }
    }
  }
}
export async function UpdatePharmacyName(
  patientid: any,
  patient: any,
  sp: SelectedPharmacy
) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl =
      Configurations.API +
      "/UpdatePharmacyName?pharmacyName=" +
      sp.PHARMACY_NAME +
      "&patientid=" +
      patientid;

    const config = {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    const response = await fetch(targetUrl, config);
    UpdatePharmacyDetails(patient, sp);
    GetMedications(patientid);
    if (!response.ok) {
      logError();
    } else {
      const result = await response.json();
      return result;
    }
  }
}

export async function GetCCDAHTML(id: number) {
  const targetUrl = Configurations.API + "/GetCCDAHTML?CCDAID=" + id;
  const token = sessionStorage.getItem("PP_Auth_Token");
  const headers = new Headers();
  headers.append("Authorization", "Bearer " + token);
  const response = await fetch(targetUrl, { headers: headers });

  if (!response.ok) {
    logError();
  } else {
    return await response.text();
  }
}

export async function VerifyAdmin(login: Login) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    //FB 7111
    //FB 8401 Begin
    const targetUrl = Configurations.API + "/verifyLogin?websiteID=" + emrConfig.WebsiteID +
      "&username=" + login.Username + "&password=" + encodeURIComponent(login.Password) + "";
    //FB 8401 End
    const result = await fetch(targetUrl);
    if (result.ok) {
      var data = await result.json();
      return data;
    } else if (result.status == 404) {
      return result.status;
    }
    else {
      logError();
    }
  }
}

export async function FindPatients(patient: Patient, dob: any) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    patient.WebSiteID = emrConfig.WebsiteID;
    //patient.PatientDOB = patient.PatientDOB == null ? new Date() : patient.PatientDOB;
    const targetUrl = Configurations.API + "/api/patient/FindPatient?dob=" + dob;
    //const targetUrl = "http://localhost:24824" + "/api/patient/FindPatient?dob=" + dob;
    const config = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },

      body: JSON.stringify(patient),
    };
    const response = await fetch(targetUrl, config);
    if (!response.ok) {
      logError();
    } else {
      const data = await response.json();
      if (data.length > 0) {
        return data.map((key: any) => {
          return {
            PatientFirstName: key.patientFirstName,
            PatientLastName: key.patientLastName,
            PatientDOB: key.patientDOB,
            PatientGender: key.patientGender,
            EMRID: key.emrid,
            PatientEmail: key.patientEmail,
            PatientCellPhone: key.patientCellPhone,
            Patient_N: key.patientID,
            // FB 7874
            Login: key.login,
            WebSiteID: key.webSiteID,
            PatientPassword: key.patientPassword
          } as Patient;
        });
      }
    }
  }
}

export async function DisablePatient(patientID: number) {
  const targetUrl = Configurations.API + "/api/patient/disablepatient?patientID=" + patientID;
  const config = {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },

  };
  const response = await fetch(targetUrl, config);
  if (!response.ok) {
    logError();
  } else {
    return "Patient disabled successfully!";
  }
}

export async function UpdateLogo(logo: HeaderLogo) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    logo.WebsiteID = emrConfig.WebsiteID;
    const targetUrl = Configurations.API + "/Registration/UpdateLogo";
    const config = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },

      body: JSON.stringify(logo),
    };
    const response = await fetch(targetUrl, config);
    //const response = await fetch(targetUrl);
    if (!response.ok) {
      logError();
    } else {
      return response.status;
    }
  }
}

export async function GetLogo() {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl = Configurations.API + "/GetLogo?websiteid=" + emrConfig.WebsiteID;

    const result = await fetch(targetUrl);
    if (result.status == 200) {
      var data = await result.text();
      return data;
    }
  }
}

export async function GetClinicalDocuments(patient_n: number) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    //FB 8401 Begin
    const targetUrl = Configurations.API + "/api/Patient/GetClinicalDocuments?websiteID=" + emrConfig.WebsiteID
      + "&patient_n=" + patient_n + "&password=Welcome_to_the_real_world";
    //FB 8401 End
    const response = await fetch(targetUrl);
    if (!response.ok) {
      logError();
    } else {
      const data = await response.json();
      if (data.length > 0) {
        return data.map((key: any) => {
          return {
            CATEGORY_N: key.CATEGORY_N,
            CATEGORY_LABEL: key.CATEGORY_LABEL,
            SESSION_N: key.SESSION_N,
            SESSION_DATE: key.SESSION_DATE,
            IS_NOTE_COMPLETE_FLAG: key.IS_NOTE_COMPLETE_FLAG
          } as ClinicalDocument;  //FB 10390
        });
      }
    }
  }
}

export async function GetClinicalDocument(session_n: number) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    //FB 8401 Begin
    const targetUrl = Configurations.API + "/api/patient/GetClinicalDocument?websiteID=" + emrConfig.WebsiteID +
      "&session_n=" + session_n + "&password=Welcome_to_the_real_world";
    //FB 8401 End
    const response = await fetch(targetUrl);

    if (!response.ok) {
      logError();
    } else {
      let bytes: Blob = await response.blob();
      return bytes;
    }
  }
}

export async function GetAdminSettingValue(setting: string) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    //FB 8401 Begin
    const targetUrl = Configurations.API + "/GetAdminSettingValue?websiteID=" + emrConfig.WebsiteID +
      "&settingName=" + setting;
    //FB 8401 End
    const response = await fetch(targetUrl);
    if (!response.ok) {
      logError();
      return Promise.reject();
    }
    else {
      let data = await response.json();
      return data;
    }
  }
}

export async function GetMessageReplies() {
  try {
    const allow_message_reply = await GetAdminSettingValue("AllowPortalReplies");

    // Normalize return type: could be ["true"] or "true"
    let settingValue;

    if (Array.isArray(allow_message_reply)) {
      settingValue = allow_message_reply[0];
    } else {
      settingValue = allow_message_reply;
    }

    return String(settingValue).toLowerCase() === "true";
  } catch (error) {
    logError();
    return Promise.reject(error);
  }
}

//FB 8024 - Begin
export async function GetAppointmentTypeFromAdmin(adminSettting: string) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl = emrConfig.EMRURL + `/api/Provider/GetAppointment?appointmentType=` + adminSettting;
    const response = await fetch(targetUrl);

    if (!response.ok) {
      logError();
      return Promise.reject();
    }
    else {
      let data = await response.json();
      return data;
    }
  }
}

export async function ValidateAppointmentType(appointmentTypes: string) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl = emrConfig.EMRURL + `/api/Provider/ValidateAppointmentType?appointmentTypes=` + appointmentTypes;
    const response = await fetch(targetUrl);

    if (!response.ok) {
      logError();
      return Promise.reject();
    }
    else {
      let data = await response.json();
      return data;
    }
  }
}
//FB 8024 End

//FB 7075
export async function SendDirectEmail(attachmentPaths: any, recipientAddress: any, subject: any, body: any) {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const token = sessionStorage.getItem("PP_Auth_Token");
    const headers = new Headers();
    headers.append("Authorization", "Bearer " + token);
    const targetUrl = Configurations.API + "/SendDirectEMail?websiteID=" + emrConfig.WebsiteID + "&attachmentPaths=" + attachmentPaths +
      "&recipientAddress=" + recipientAddress + "&subject=" + subject + "&body=" + body;
    const config = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    };
    let result: Response = await fetch(targetUrl, config).then((response) => { return response; }).catch((e) => {
      return e;
    })

    if (result.ok) {
      var data = await result.json();
      return data;
    }
  }
}

//FB 9639
export async function GetEmployeeGroups() {
  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let emrConfig = JSON.parse(obj) as EMRConfig;
    const targetUrl = Configurations.API + "/GetEmployeeGroups?websiteID=" + emrConfig.WebsiteID;
    const token = sessionStorage.getItem("PP_Auth_Token");
    const headers = new Headers();
    headers.append("Authorization", "Bearer " + token);
    const response = await fetch(targetUrl, { headers: headers });

    if (!response.ok) {
      logError();
    } else {
      const data = await response.json();
      return data;
    }
  }
}

export async function logError() {
  var JSAlert = require("js-alert");
  JSAlert.alert(
    "Something went wrong. Please try again later.",
    null,
    JSAlert.Icons.Warning
  );
}